import { createClient } from 'push-js-client';
import { getProperty } from '@/common/oldMobile';
import reframe from 'nike-re-framejs';
import snapshotClient from '@/_http/axiosSnapshotClient';
import { pushJSLogger } from 'nike-ui/src/common/logging/push/log';
import { onPushConnectionStatusChanged, PushConnectionStatus } from 'nike-ui/src/common/push/usePushConnectionStatus';
import { jwtTokenPromise } from 'nike-ui/src/common/axios/jwtTokenPromise';
import { isProfileIgnorePushSequenceEnabled } from 'nike-ui/src/profiles';

const pushConfig = {
    authorize: jwtTokenPromise,
    webSocketAddress: getProperty('pushWsAddress'),
    sockJsAddress: getProperty('pushSockJsAddress'),
    snapshotAxiosInstance: snapshotClient,
    logger: pushJSLogger,
    pingInterval: 1250,
    checkSequence: !isProfileIgnorePushSequenceEnabled()
};
export const pushClient = createClient(pushConfig);

window.push = pushClient;

pushClient.on('open', () => reframe.dispatch(onPushConnectionStatusChanged(PushConnectionStatus.Connected)));
pushClient.on('close', () => reframe.dispatch(onPushConnectionStatusChanged(PushConnectionStatus.Disconnected)));

export const close = function(db) {
    pushClient.close();
    return db;
};
